export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '北京市丰台区航天标准大厦9层',
  uc_host: 'http://user.xal.com.cn',
  site_host: 'http://meiti.xal.com.cn',
  special_url: '/',
  site_title: '推爆传媒-软文精准营销平台',
  welcome_title: '推爆传媒 — 软文精准营销平台！',
  site_short_title: '推爆传媒',
  site_subtitle: '软文精准营销平台',
  company_name: '推曝（北京）广告有限公司',
  copyright: '© 2024 推曝（北京）广告有限公司',
  logo: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/241031/200b7a28b14117d761ad0e5bda556cbb.png',
  favicon: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/241031/f3cdb365566dfd4e70f556b99607553b.png',
  payment: '',
  qq: '5137258',
  tel: '13661114192',
  company_account_id: '91040078801800000716',
  company_bank: '上海浦东发展银行股份有限公司北京雍和支行',
  company_bank_name: '推曝（北京）广告有限公司',
  alipay_account_id: '13910189327',
  alipay_name: '推曝（北京）广告有限公司',
  alipay_pic: '',
  section_id: 5338706,
  belonger_id: 5338706,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 